import React from "react";
import { motion } from "framer-motion";
import { MessageCircleHeart } from "lucide-react";

/**
 * CoachNoteCard — a personal note from the coach shown on the athlete
 * dashboard for the full week. Stays subtle and warm — this isn't a
 * nudge, it's a direct message.
 *
 * Props:
 *   note: { message, coach_name, week_start, updated_at }
 */
export const CoachNoteCard = ({ note }) => {
  if (!note || !note.message) return null;

  const coachName = note.coach_name || "Your coach";

  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative bg-gradient-to-br from-purple-600/15 via-surface to-surface border border-purple-500/30 rounded-xl p-5 sm:p-6 overflow-hidden"
      data-testid="coach-note-card"
    >
      <div className="absolute -top-10 -right-10 w-44 h-44 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
          <MessageCircleHeart className="w-5 h-5 text-purple-300" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-purple-300 text-[11px] font-bold uppercase tracking-widest mb-1">
            Note from {coachName}
          </p>
          <p
            className="text-white text-base leading-relaxed whitespace-pre-wrap"
            data-testid="coach-note-body"
          >
            {note.message}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default CoachNoteCard;
